import { FC } from "react";
import { ListUserPaymentHistory } from "../dashboard/widget/ListUserPaymentHistory";

const Payments: FC = () => {
  return <ListUserPaymentHistory inputVisible />;
};

export { Payments };
